import axios from 'axios';
import config from "@/config/constants.js";

export default {
  namespaced: true,
  state: {
    status: '',
    terms_and_conditions: '',
    privacy_policy: '',
    faqs: [],
    licenses: []
  },
  mutations: {
    loading(state) {
      state.status = 'loading';
    },
    status(state, status) {
      state.status = status;
    },
    success(state) {
      state.status = '';
    },
    addFaqs(state, faqs) {
      state.faqs = [];
      for (const prop in faqs) {
        state.faqs.push({
          question: faqs[prop].question,
          answer: faqs[prop].answer,
        });
      }
    },
    addTerms(state, terms) {
      state.terms_and_conditions = terms;
    },
    addPolicy(state, policy) {
      state.privacy_policy = policy;
    },
    licenses(state, payload) {
      state.licenses = payload;
    }
  },
  actions: {
    get_faqs: async function ({commit, state}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        const dataFaqs = await axios.get(config.api_url + 'faqs');
        commit('addFaqs', dataFaqs.data);
        resolve(state.faqs);
      });
    },
    get_terms: async function ({commit, state}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        const dataTerms = await axios.get(config.api_url + 'terms_and_conditions');
        commit('addTerms', dataTerms.data['description']);
        resolve(state.terms_and_conditions);
      });
    },
    get_policy: async function ({commit, state}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        const dataPolicy = await axios.get(config.api_url + 'policy_privacy');
        commit('addPolicy', dataPolicy.data['description']);
        resolve(state.privacy_policy);
      });
    },
    get_licenses: async ({commit}) => {
      return new Promise((resolve, reject) => {
        axios.get(config.api_url + 'legal/licenses')
          .then(response => {
            commit("licenses", response.data.licenses);
            resolve(response.data.licenses);
          })
          .catch(error => reject(error));
      });
    }
  },
};